// extracted by mini-css-extract-plugin
export default {"container":"WarehouseInventory_container__1p6Kx","tableCard":"WarehouseInventory_tableCard__nUAUN"};